define(['jquery',
        'core/loading-animation',
        'core/urls'],
    function($, loading_animation, urls) {

        return {
            init: function() {
                $('#welcomeModal').modal('show');
                loading_animation.complete();
                $('a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
                    var selectedTss = e.target.getAttribute('data-tss');
                    var selectedTssHandle = e.target.getAttribute('data-tss-handle');
                    $('#setTssButton').prop('disabled', false).text('Continue with ' + selectedTss);
                    $('#setTssHandle').val(selectedTssHandle);                   
                });

                document.querySelectorAll(".tss-wrapper").forEach(element => {
                    element.addEventListener("click", () => {
                        $('#setTssButton').addClass("blink");
                        
                        setTimeout(() => {
                            $('#setTssButton').removeClass("blink");
                        }, 300)
                        
                        $('html,body').animate({scrollTop: document.body.scrollHeight},"fast");
                    })
                })

                // after the first click on the 'Continue with TSS' button, prevent additional clicks
                var $setTssButton = $('#setTssButton');
                $setTssButton.parents('form').submit(function() {
                    $setTssButton.prop('disabled', true);
                });
            }
        };
    }
);